const DEFAULT_LOCAL_AUTH_REDIRECT = "http://localhost:3000";
const PRODUCTION_AUTH_REDIRECT = "https://legacygrowthinc.com";

function normalizeOrigin(url: string): string {
  return url.replace(/\/+$/, "");
}

export function getAuthRedirectBase(): string {
  const configured = import.meta.env.VITE_AUTH_REDIRECT_URL as string | undefined;
  if (configured && configured.trim()) {
    return normalizeOrigin(configured.trim());
  }
  // In production builds without the env var, fall back to the real domain.
  if (import.meta.env.PROD) {
    return PRODUCTION_AUTH_REDIRECT;
  }
  return DEFAULT_LOCAL_AUTH_REDIRECT;
}
